(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name mapsService
     *@description
     *Servicio de Mapas
     */

    angular
        .module('app')
        .factory('mapsService', mapsService);

    mapsService.$inject = ["$http","espaiService","$filter","autorService","$location","$timeout"];

    function mapsService($http,espaiService,$filter,autorService,$location,$timeout) {    

    	var maps = {};
    	var markers = [];
        var lines = [];
    	var options = {
            imagePath: '/static/images/m',
            maxZoom: 15,
            ignoreHidden: true
        };
        var markerCluster ;
        maps.gmaps=null;
        maps.loadedMap=null;
        maps.benvinguts = true;
        maps.eventPan = true;
        maps.eventsEnabled = false;

        maps.setbenvinguts = function(b)
        {
            maps.benvinguts = true;
        };

        var bounds = new google.maps.LatLngBounds();
		/**
        * @ngdoc method
        * @name Polyline
        * @memberof mapsService
        * @desciption
        * Crea un poligono en un mapa
        */
       var NRuta=0;
        maps.Polyline = function(ruta,autor){
			
            if(ruta.data.punts_json.replace("None","").trim()=="")
                return ;

			var obj = JSON.parse(ruta.data.punts_json);
            
            if(!obj)
                return;

          	var coordinates = [];

        	for (var i = 0; i < obj.length; i++) {
        		
        		coordinates.push({lat: obj[i][0], lng: obj[i][1]});
        	}
            //console.log(coordinates);
            var index = lines.length;
            lines[index] = {};
            lines[index].autor = autor;
            lines[index].ruta = ruta.id;
        	lines[index].line = new google.maps.Polyline({
          		path: coordinates,
          		geodesic: true,
          		strokeColor: '#b5b92d',
          		strokeOpacity: 0.5,
          		strokeWeight: 4,
                visible:true
        	});
            
              //  console.log(maps.gmaps);
                lines[index].line.setMap(maps.gmaps);

        	NRuta++;
            //console.log(NRuta);
            
    	};
        /**
        * @ngdoc method
        * @name setVisiblePolyline
        * @memberof mapsService
        * @desciption
        * Borra un poligono en un mapa
        */
        maps.setVisiblePolyline = function(ruta,v)
        {
                    console.log(lines);

            for (var i = 0; i < lines.length; i++) {
                if(lines[i].ruta == ruta )
                {
                    console.log("SET ENABLE");
                    lines[i].line.setVisible(true);
                }
            }  
            
            

        };

        /**
        * @ngdoc method
        * @name setVisiblePolyline
        * @memberof mapsService
        * @desciption
        * Borra un poligono en un mapa
        */
        maps.setInvisiblePolylines = function()
        {
            for (var i = 0; i < lines.length; i++) {
                
                    lines[i].line.setVisible(false);
                

            }  
        };

              /**
        * @ngdoc method
        * @name setVisiblePolyline
        * @memberof mapsService
        * @desciption
        * Borra un poligono en un mapa
        */
        maps.setVisiblePolylineRuta = function(ruta,v)
        {
            for (var i = 0; i < lines.length; i++) {
                if(lines[i].ruta == ruta )
                {
                    lines[i].line.setVisible(v);
                }

            }  
        };

		/**
        * @ngdoc method
        * @name centerMap
        * @memberof mapsService
        * @desciption
        * Centra el mapa dado uin espacio
        */
        maps.centerMap = function(espai,fit)
        {
            
            console.log("CENTER MAP");
            if(!espai){
                return true;
            }
            var b = maps.eventPan;
            maps.eventPan = true; 
            var LatLong = new google.maps.LatLng(espai.data.latitud, espai.data.longitud);
            var c = new google.maps.LatLngBounds();
            
            c.extend(LatLong);
            $timeout(function(){
                if(fit)
                    maps.gmaps.fitBounds(c);
                maps.gmaps.setCenter(c.getCenter());
            });
            maps.eventPan = b;
        };
        /**
        * @ngdoc method
        * @name centerMapEspais
        * @memberof mapsService
        * @desciption
        * Centra el mapa dado uin espacio
        */
        maps.centerMapEspais = function(espais)
        {
            console.log("centerMapEspais");
            if(!espais.length){
                return true;
            }
            var LatLong = null;
            var b = maps.eventPan;
            maps.eventPan = true; 
            var c = new google.maps.LatLngBounds();
            console.log("centerMapEspais for");
            for (var i = 0; i < espais.length; i++) {
                console.log(espais[i]);
                if(espais[i]){
                    LatLong = new google.maps.LatLng(espais[i].data.latitud, espais[i].data.longitud);
                    c.extend(LatLong);
                }
            }
            console.log("centerMapEspais timeout");
            $timeout(function(){
                maps.gmaps.fitBounds(c);
                maps.gmaps.setCenter(c.getCenter());
            });
            maps.eventPan = b;
            
            console.log("CENTRADO");
            return true;
        };


        maps.reset = function()
        {
            markerCluster.clearMarkers();
            markerCluster.setMap(null);

            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }

            for (var i = 0; i < lines.length; i++) {
                    lines[i].line.setMap(null);
            }  
        };

        /**
        * @ngdoc method
        * @name setMapOnAll
        * @memberof mapsService
        * @desciption
        * Centra el mapa dado uin espacio
        */

        maps.setMapOnAll = function(ruta) {
            var b = new google.maps.LatLngBounds();

            for (var i = 0; i < markers.length; i++) {
                 
                var autor = autorService.getAutorByID(markers[i].autor);
                
                //markers[i].setMap(map);
                //markerCluster.removeMarker(markers[i]);
                //console.log(mc[i]);
                //mc[i].setVisible(autor.visible);

                markers[i].setVisible(autor.visible);
                if(autor.visible)
                    b.extend(markers[i].position);
                
                if(ruta)
                {
                    maps.setVisiblePolyline(ruta,true);
                    /*
                        console.log("RUTA");
                        console.log(ruta);
                        console.log("RUTA END");
                    */
                    if(markers[i].ruta_id.indexOf(ruta)>-1 )
                    {
                        //console.log("LOOKUPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP");
                        //var LatLong = new google.maps.LatLng(markers[i].position.lat, markers[i].position.long);
                        
                        markers[i].setVisible(true);    
                        maps.setVisiblePolyline(autor.id,true);
                    }else
                    {
                        markers[i].setVisible(false);    
                    }
                }
                
            }
            markerCluster.repaint();
            
            $timeout(function(){
                maps.gmaps.fitBounds(b);
                maps.gmaps.setCenter(b.getCenter());
            });
            
        };


        var markerActive = null;


        maps.setActiveMarker = function(espai)
        {
            console.log("ACTIVANDO->"+espai);
            console.log(markerActive);
            if(markerActive)
            {
                var img={
                    url : markerActive.inactive,
                    size: new google.maps.Size(63, 63),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 63)
                };
                markerActive.setIcon(img);                                    
            }
            for (var i = 0; i < markers.length; i++) {
                if(markers[i].espai_id == espai){
                    console.log("localizado");
                    var image={
                        url : markers[i].active,
                        size: new google.maps.Size(63, 63),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(0, 63)
                    };
                        
                    markers[i].setIcon(image);                                    
                    markerActive = markers[i];
                }
            }
        };


		/**
        * @ngdoc method
        * @name addMarkers
        * @memberof mapsService
        * @desciption
        * Añade los markers al mapa y centra el mapa .
        */
    	maps.addMarkers = function()
    	{
            //setMapOnAll(null);
    		var monument = 0 ;
            var color = 0 ;
            var slug ="";
            markers = [];
    		console.log(espaiService.data.length);
    		for (var i = 0; i < espaiService.data.length; i++) {
                var autor = autorService.getAutorByID(espaiService.data[i].data.autor);
                monument = 0 ;
                color = 0;

                if(autor.visible){

                    slug = espaiService.getSlug(espaiService.data[i]);


                    if(espaiService.data[i].data.monument != ''){
                        
                        monument = 1;
                    }
                    if(slug == $location.path())
                    {
                        color = 1;
                    }
                   // console.log($location.path());


    			    var image={
                        url : "/api/v1/image?autor="+espaiService.data[i].data.autor+"&color="+color+"&monument="+monument,
                        size: new google.maps.Size(63, 63),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(0, 63)
                    };
    			 
    			    var LatLong = new google.maps.LatLng(espaiService.data[i].data.latitud, espaiService.data[i].data.longitud);
    			    var marker = new google.maps.Marker({
                    	position: LatLong,
                    	map: maps.gmaps,
                    	title: espaiService.data[i].data.nom_ca,
                    	icon: image,
                        autor: espaiService.data[i].data.autor,
                        espai_id: espaiService.data[i].id,
                    	ruta_id: espaiService.data[i].ruta,
                        inactive:"/api/v1/image?autor="+espaiService.data[i].data.autor+"&color=0&monument="+monument,
                        active:"/api/v1/image?autor="+espaiService.data[i].data.autor+"&color=1&monument="+monument,
                        url:slug,
                        visible:true
            	    });
                    //espaiService.data[i].marker = marker;
            	    markers.push(marker);
                    bounds.extend(LatLong);

                    google.maps.event.addListener(marker, 'click', function() {
                        
                        if(markerActive)
                        {
                            var img={
                                url : markerActive.inactive,
                                size: new google.maps.Size(63, 63),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 63)
                            };
                            markerActive.setIcon(img);                                    
                        }

                        var image={
                            url : this.active,
                            size: new google.maps.Size(63, 63),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 63)
                        };

                        
                        this.setIcon(image);                                    
                        markerActive = this;
                        $location.path(this.url);

                    }); 



                }
    		}

            
            markerCluster = new MarkerClusterer(maps.gmaps, markers, options);
            maps.gmaps.fitBounds(bounds);
            maps.gmaps.setCenter(bounds.getCenter());
            console.log("ELS ZOOM ES "+maps.gmaps.getZoom() +"  ·   " +maps.gmaps.getCenter() );
            maps.gmaps.setZoom(maps.gmaps.getZoom()+1);

            maps.eventsEnabled = true;

            
            //console.log(markers.length);
            //console.log(markers);
            //markerCluster.repaint();


    	};

        maps.eventZoom = function()
        {
            console.log("EVENT ZOOM ENABLED");
            google.maps.event.addListener(maps.gmaps, 'zoom_changed', function() {
                if(!maps.eventsEnabled)
                    return ;

                if(maps.eventPan && markerCluster)
                {

                    console.log("ZOOM");
                    //autorService.invisibleAll();
                    $timeout(function() {
                    var markersVisibles = markerCluster.getMarkers();
                    
                    //maps.setInvisiblePolylines();
                    var massautor = [] ;
                    $.each(markersVisibles, function(j, marker) {
                        if (maps.gmaps.getBounds().contains(marker.getPosition())) {
                            
                            massautor.push(marker.autor);
                           // marker.setVisible(true);

                            /*$.each(espaiService.data, function(i, espai) {
                                var LatLong = new google.maps.LatLng(espai.data.latitud, espai.data.longitud);
                                //var dealerLatLong = new google.maps.LatLng(dealer.svcLocation.latitude, dealer.svcLocation.longitude);
                                if (marker.getPosition().lat() == LatLong.lat() && marker.getPosition().lng() == LatLong.lng()) {
                                    //dealersVisible.push(dealer);
                                    var autor = autorService.getAutorByID(espai.data.autor);
                                    //autorService.setVisible(autor.id,true);
                                    massautor.push(autor.id);
                                    //maps.setVisiblePolyline(autor.id,true);
                                }
                            });*/
                        }
                    });
                    autorService.setVisibleMass(massautor);
                    markerCluster.repaint();
                        //drawDealers(dealersVisible);
                        
                    },500); 
                    
                }
            });

        };

        maps.eventDrag = function()
        {
            console.log("EVENT DRAG ENABLED");
             google.maps.event.addListener(maps.gmaps, 'dragend', function() {
                 if(!maps.eventsEnabled)
                    return ;
                if(maps.eventPan)
                {
                    
                    //autorService.invisibleAll();
                    $timeout(function() {
                    console.log("dragend");
                    var markersVisibles = markerCluster.getMarkers();
                    
                    //maps.setInvisiblePolylines();
                    var massautor = [] ;
                    $.each(markersVisibles, function(j, marker) {

                        if (maps.gmaps.getBounds().contains(marker.getPosition())) {
                            
                            massautor.push(marker.autor);
                            //marker.setVisible(true);
                            /*$.each(espaiService.data, function(i, espai) {
                                var LatLong = new google.maps.LatLng(espai.data.latitud, espai.data.longitud);
                                //var dealerLatLong = new google.maps.LatLng(dealer.svcLocation.latitude, dealer.svcLocation.longitude);
                                if (marker.getPosition().lat() == LatLong.lat() && marker.getPosition().lng() == LatLong.lng()) {
                                //dealersVisible.push(dealer);
                                    var autor = autorService.getAutorByID(espai.data.autor);
                                    //autorService.setVisible(autor.id,true);
                                    massautor.push(autor.id);
                                    //maps.setVisiblePolyline(autor.id,true);
                                }
                            });*/
                        }
                    });
                    autorService.setVisibleMass(massautor);
                    markerCluster.repaint();
                        //drawDealers(dealersVisible);
                        
                    },500); 

                }
            });

        };

    	maps.setGmaps = function(gmaps)
    	{
            console.log("SET EVENTS");
    		maps.gmaps = gmaps;
            maps.eventZoom();
            maps.eventDrag();
            
    	};


        maps.geolocation = function()
        {
             // Try HTML5 geolocation.
                    console.log(navigator.geolocation);
                    if (navigator.geolocation) {
                        console.log("centrando");
                        navigator.geolocation.getCurrentPosition(function(position) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };
                            maps.gmaps.setCenter(new google.maps.LatLng(pos.lat,pos.lng));
                            maps.gmaps.setZoom(15);
                            console.log("centrado");
                        }, function() {
                            //handleLocationError(true, infoWindow, map.getCenter());
                        });
                    } else {
                            // Browser doesn't support Geolocation
                           // handleLocationError(false, infoWindow, map.getCenter());
                    }
                
        };

    	return maps;
    }



})();
